import { useTranslation } from "react-i18next";

import TableCustom from "../../../component/table/tableCustom";
import TableRowCommon from "../../../component/table/TableRowCommon";
import ButtonCustom from "../../../component/button/buttonCustom";
import { colors } from "../../../constants/colors";
import { IZoneRow, paginate } from "./stallPicker.utils";

export interface IZoneTableProps {
  /** กรอง keyword มาแล้ว แต่ยังไม่ตัดหน้า */
  rows: IZoneRow[];
  /** 1-based ตาม TableCustom */
  page: number;
  pageLimit: number;
  onPageChange: (page: number) => void;
  onPageLimitChange: (pageLimit: number) => void;
  onOpenZone: (zoneId: number) => void;
}

export default function ZoneTable(props: IZoneTableProps) {
  const { t } = useTranslation();

  const headCells = [
    { id: "no", label: "#", align: "center", width: 60 },
    { id: "zoneName", label: t("MARKET_MAP.HEADCELL.ZONE_H"), align: "left" },
    { id: "countAll", label: t("MARKET_MAP.HEADCELL.COUNT_ALL"), align: "center" },
    { id: "countBlank", label: t("MARKET_MAP.HEADCELL.COUNT_BLANK"), align: "center" },
    { id: "countReserve", label: t("MARKET_MAP.HEADCELL.COUNT_RESERVE"), align: "center" },
    { id: "countContract", label: t("MARKET_MAP.HEADCELL.COUNT_CONTRACT"), align: "center" },
    { id: "action", label: t("MARKET_MAP.HEADCELL.ACTION"), align: "center", width: 160 },
  ];

  /** absoluteIndex = ลำดับในชุดที่กรองแล้วทั้งหมด ไม่ใช่แค่ในหน้านี้ */
  const renderData = (row: IZoneRow, absoluteIndex: number) => {
    const objRenderData = {
      key: `zone-${row.zoneId}`,
      id: `zone-${row.zoneId}`,
      obj: row,
      columns: [
        { option: "TEXT", align: "center", label: absoluteIndex + 1 },
        { option: "TEXT", align: "left", label: row.zoneName || "-" },
        { option: "TEXT", align: "center", label: row.countAll },
        {
          option: "TEXT",
          align: "center",
          label: row.countBlank,
          style: { color: row.countBlank > 0 ? colors.themeSecondColor : colors.textLightGray },
        },
        { option: "TEXT", align: "center", label: row.countReserve },
        { option: "TEXT", align: "center", label: row.countContract },
        {
          option: "COMPONENT",
          align: "center",
          width: 160,
          component: (
            <ButtonCustom
              variant="outlined"
              textButton={t("MARKET_MAP.BUTTON.VIEW_STALL")}
              btnStyle={{ fontSize: "0.875rem", padding: "4px 12px" }}
              onClick={() => props.onOpenZone(row.zoneId)}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  return (
    <TableCustom
      headCells={headCells}
      customScroll
      page={props.page}
      pageLimit={props.pageLimit}
      sortType={"ASC"}
      sortBy=""
      rowCount={props.rows.length}
      tableMinWidth={900}
      rowsData={paginate(props.rows, props.page, props.pageLimit).map((row, index) =>
        renderData(row, (props.page - 1) * props.pageLimit + index)
      )}
      onSort={() => {}}
      setPage={props.onPageChange}
      setPageLimit={props.onPageLimitChange}
    />
  );
}
